module.exports = require('./helpers/bundle-url').getBundleURL('9fDO5') + "logo-dark.eefe0b7f.svg";